import React from 'react';
import { Instagram, ArrowUpRight } from 'lucide-react';
import { gallery, socialLinks } from '../../data/mock';

const tiles = gallery.slice(0, 6);

export default function InstagramFeed() {
  return (
    <section className="py-20 md:py-24" data-testid="home-instagram-feed">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">
              <Instagram className="w-3.5 h-3.5" /> On the Gram
            </div>
            <h2 className="font-display font-bold text-4xl md:text-5xl text-splash-green leading-tight">
              Follow the splash
            </h2>
            <div className="mt-2 font-semibold text-splash-teal text-base md:text-lg break-words">{socialLinks.instagramHandle}</div>
          </div>
          <a
            href={socialLinks.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow-btn"
            className="self-start md:self-auto inline-flex items-center gap-2 rounded-full bg-splash-green hover:bg-splash-greenDark text-white px-6 py-3 font-semibold btn-transition"
          >
            <Instagram className="w-4 h-4" /> Follow on Instagram
          </a>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {tiles.map((t, i) => (
            <a
              key={t.src}
              href={socialLinks.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="group relative aspect-square rounded-2xl overflow-hidden bg-splash-creamDark"
            >
              <img src={t.src} alt={t.caption} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-splash-green/0 group-hover:bg-splash-green/55 transition-colors duration-300 flex items-end p-4">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity text-white text-sm font-semibold inline-flex items-center gap-1">
                  {t.caption} <ArrowUpRight className="w-4 h-4 shrink-0" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
